<template>
    <div class="card">
        <div class="card-head">
            <div class="row">
                <div v-if="(currentJourney != null)" class="col-xs-1 card-head-button">
                    <button class="buttom-close" @click="$emit('removeCurrent')">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                </div>
                <div :class="'col-xs-' + ((currentJourney != null) ? '11' : '12') + ' card-head-title'">
                    <b>{{ name }} - {{ getDate(date) }}</b>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div v-if="(currentJourney == null)" class="row">
                <div class="col-xs-3 col-lg-3 geralSummary">
                    <i class="fa fa-fw fa-route"></i> {{ totalRoute }} rotas
                </div>
                <div class="col-xs-3 col-lg-3 geralSummary">
                    <i class="fa fa-fw fa-truck-loading"></i> {{ totalDelivery }} entr.
                </div>
                <div class="col-xs-3 col-lg-3 geralSummary">
                    <i class="fa fa-fw fa-road"></i> {{ getDistance(totalDistance) }}
                </div>
                <div class="col-xs-3 col-lg-3 geralSummary">
                    <i class="fa fa-fw fa-weight-hanging"></i> {{ getWeight(totalWeight) }}
                </div>
                <div class="col-xs-12 col-lg-12 geralDroppedNodesSummary">
                    <i class="fa fa-fw fa-boxes"></i> {{ totalDroppedNode }} entregas desvinculadas
                </div>
            </div>
            <div v-else class="row">
                <div class="col-xs-12 tab">
                    <button :class="'buttom-tab ' + ((summary == 'route') ? 'active' : '')" @click="changeSummary('route')">
                        Rota
                    </button>
                    <button :class="'buttom-tab ' + ((summary == 'itinerary') ? 'active' : '')" @click="changeSummary('itinerary')">
                        Itinerário
                    </button>
                </div>
                <div v-if="summary == 'route'" class="col-xs-12 tab-totalRoute">
                    <div class="route">
                        <ul class="list-points">
                            <li class="list-points-item" v-for="(point, index) in currentJourney.points" :key="index" :style="'border-left: 4px solid ' + currentJourney.color">
                                <a v-if="(point.isDC)" href="#" @dblclick="dblClick(point.objectMap)" @mouseover="onMouseOver(point.objectMap)"  @mouseout="onMouseOut(point.objectMap)">
                                    <span class="route-marker dc-point-icon" style="background-color: #303030"></span>
                                    <span class="route-icon dc-point-icon" style="color: #303030"><i class="fas fa-home"></i></span>
                                    <span v-if="currentJourney.timeConstraints" class="route-time">{{ getTimeHour(point.startTimeRoute) }}</span>
                                    <span v-if="index == 0" class="route-distance">{{ getDistance(point.distanceBetween) }}</span>
                                    <p class="route-title"><b>Centro de Distribuição</b></p>
                                    <p class="route-name"><b>{{ point.dcName }}</b></p>
                                    <p class="route-description"><b> {{ currentJourney.points[0].customerName }}</b></p>
                                    <p class="route-description capitalized"><i class="fas fa-map-marker-alt"></i> {{ currentJourney.points[0].addressStreet.toLowerCase() }},  {{ currentJourney.points[0].addressNumber.toLowerCase() }} - {{ currentJourney.points[0].addressNeighborhood.toLowerCase() }}</p>
                                    <p class="route-description capitalized"><i class="fas fa-globe-americas"></i> {{ currentJourney.points[0].addressCity.toLowerCase() }} - {{ currentJourney.points[0].addressUf }}, {{ currentJourney.points[0].addressPostalCode }}</p>
                                </a>
                                <a v-else-if="(!point.isDC && (point.movimentTypeCode == default_moviment_type_code))" href="#" @dblclick="dblClick(point.objectMap)" @mouseover="onMouseOver(point.objectMap)"  @mouseout="onMouseOut(point.objectMap)">
                                    <span class="route-marker route-stopping-marker stopping-point-icon" :style="'background-color: ' + currentJourney.color"></span>
                                    <span class="route-icon stopping-point-icon" :style="'color: ' + currentJourney.color + '; left:' + (point.sequence < 10 ? '53px' : (point.sequence < 100 ? '50px' : '46px'))">{{ point.sequence }}</span>
                                    <span v-if="currentJourney.timeConstraints" class="route-time">{{ getTimeHour(point.startTimeRoute) }}</span>
                                    <span v-if="(index != (currentJourney.points.length - 1))" class="route-distance">{{ getDistance(point.distanceBetween) }}</span>
                                    <p class="route-title"><b>Entrega: {{ point.documentNumber }} </b></p>
                                    <p class="route-name"><b>{{ point.customerName }}</b></p>
                                    <p class="route-description route-stopping"><span class="route-stopping-text"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span></p>
                                    <p class="route-description capitalized"><i class="fas fa-map-marker-alt"></i> {{ point.addressStreet.toLowerCase() }},  {{ point.addressNumber.toLowerCase() }} - {{ point.addressNeighborhood.toLowerCase() }}</p>
                                    <p class="route-description capitalized"><i class="fas fa-globe-americas"></i> {{ point.addressCity.toLowerCase() }} - {{ point.addressUf }}, {{ point.addressPostalCode }}</p>
                                    <p class="route-description">
                                        <span v-if="currentJourney.timeConstraints && point.startTime && point.endTime" title="Janela de atendimento" style="margin-right: 15px"><i class="fa fa-clock"></i> {{point.startTime}} - {{point.endTime}}</span>
                                        <span v-if="point.quantity" title="Quantidade" style="margin-right: 15px"><i class="fa fa-boxes"></i> {{point.quantity}} unid.</span>
                                    </p>
                                    <p class="route-description">
                                        <span title="Peso" style="margin-right: 15px"><i class="fa fa-weight-hanging"></i> Peso {{ getWeight(point.weight) }}</span>
                                        <span v-if="point.averageWaitingTime" title="Tempo médio de descarregamento" style="margin-right: 15px"><i class="fa fa-people-carry"></i> Entrega: {{ getTime(point.averageWaitingTime) }} </span>
                                    </p>
                                    <p v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-title-lunch-time"><b class="lunch-time">INTERVALO DE ALMOÇO</b></p>
                                    <p v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-description"><i class="fa fa-utensils"></i> {{ getTime(currentJourney.lunchTime) }} de intervalo</p>
                                    <span v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-lunch-time">{{ getTimeHour(point.startLunchTime) }}</span>
                                </a>
                                <a v-else-if="(!point.isDC && (point.movimentTypeCode != default_moviment_type_code))" @dblclick="dblClick(point.objectMap)" @mouseover="onMouseOver(point.objectMap)" @mouseout="onMouseOut(point.objectMap)">
                                    <span class="route-marker delivery-point-icon" :style="'background-color: ' + currentJourney.color"></span>
                                    <span class="route-icon delivery-point-icon" :style="'color: ' + currentJourney.color + '; left:' + (point.sequence < 10 ? '53px' : (point.sequence < 100 ? '50px' : '46px'))">{{ point.sequence }}</span>
                                    <span v-if="currentJourney.timeConstraints" class="route-time">{{ getTimeHour(point.startTimeRoute) }}</span>
                                    <span v-if="(index != (currentJourney.points.length - 1))" class="route-distance">{{ getDistance(point.distanceBetween) }}</span>
                                    <p class="route-title"><b>Entrega: {{ point.documentNumber }} </b></p>
                                    <p class="route-name"><b>{{ point.customerName }}</b></p>
                                    <p class="route-description capitalized"><i class="fas fa-map-marker-alt"></i> {{ point.addressStreet.toLowerCase() }},  {{ point.addressNumber.toLowerCase() }} - {{ point.addressNeighborhood.toLowerCase() }}</p>
                                    <p class="route-description capitalized"><i class="fas fa-globe-americas"></i> {{ point.addressCity.toLowerCase() }} - {{ point.addressUf }}, {{ point.addressPostalCode }}</p>
                                    <p class="route-description">
                                        <span v-if="currentJourney.timeConstraints && point.startTime && point.endTime" title="Janela de atendimento" style="margin-right: 15px"><i class="fa fa-clock"></i> {{point.startTime}} - {{point.endTime}}</span>
                                        <span v-if="point.quantity" title="Quantidade" style="margin-right: 15px"><i class="fa fa-boxes"></i> {{point.quantity}} unid.</span>
                                    </p>
                                    <p class="route-description">
                                        <span title="Peso" style="margin-right: 15px"><i class="fa fa-weight-hanging"></i> Peso {{ getWeight(point.weight) }}</span>
                                        <span v-if="point.averageWaitingTime" title="Tempo médio de descarregamento" style="margin-right: 15px"><i class="fa fa-people-carry"></i> Entrega: {{ getTime(point.averageWaitingTime) }} </span>
                                    </p>
                                    <p v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-title-lunch-time"><b class="lunch-time">INTERVALO DE ALMOÇO</b></p>
                                    <p v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-description"><i class="fa fa-utensils"></i> {{ getTime(currentJourney.lunchTime) }} de intervalo</p>
                                    <span v-if="currentJourney.timeConstraints && point.hasLunchTime" class="route-lunch-time">{{ getTimeHour(point.startLunchTime) }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="summary == 'itinerary'" class="col-xs-12 tab-itineraries">
                    <div class="itinerary">
                        <div class="row">
                            <div class="col-xs-12 itinerary-total">
                                <b><i class="fa fa-truck"></i> {{ currentJourney.vehicleLicensePlate }}</b> <span><i class="fa fa-road"></i> {{ (currentJourney.totalDistance / 1000).toFixed(1).replace(".", ",") }} km</span> <span><i class="fa fa-stopwatch"></i> {{ getTime(currentJourney.totalTimeRoute) }}</span>
                            </div>
                            <div class="col-xs-12 col-lg-12">
                                <ul class="list-steps">
                                    <li class="list-steps-item">
                                        <a href="#" @mouseover="onMouseOverInstruction(0)"  @mouseout="onMouseOutInstruction()">
                                            <div class="row">
                                                <div class="col-xs-2 step-orientation" style="padding-right: 0px;">
                                                    <span class="fa fa-home" style="color: #000"></span>
                                                </div>
                                                <div class="col-xs-10 step-description" style="padding-left: 0px;">
                                                    <p>{{ "Iniciando na origem" }}.</p>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="list-steps-item" v-for="(step, indexStep) in currentJourney.instructions" :key="indexStep">
                                        <a href="#" @mouseover="onMouseOverInstruction(step.index)"  @mouseout="onMouseOutInstruction()">
                                            <div class="row">
                                                <div class="col-xs-2 step-orientation" style="padding-right: 0px;">
                                                    <span :class="getIconClass(step)" style="color: #000"></span>
                                                </div>
                                                <div class="col-xs-10 step-description" style="padding-left: 0px;">
                                                    <p>{{ getText(step.text) }}.</p>
                                                    <p v-if="step.type != 'WaypointReached' && step.type != 'DestinationReached'"><i>{{ getDistance(step.distance) }}</i></p>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RoutingCardSummary",

    props: {
        name: {
            type: String,
            require: true,
        },
        date: {
            type: Date,
            require: true,
        },
        totalRoute: {
            type: Number,
            require: true,
        },
        totalDelivery: {
            type: Number,
            require: true,
        },
        totalDistance: {
            type: Number,
            require: true,
        },
        totalWeight: {
            type: Number,
            require: true,
        },
        totalDroppedNode: {
            type: Number,
            require: true,
        },
        currentJourney: {
            type: Object,
            require: true,
        },
        currentSummary: {
            type: String,
            require: true,
        },
        default_moviment_type_code: {
            type: String,
            require: true,
        },
    },
    
    data: function() {
        return {
            summary: this.currentSummary,
            marker: null,
        }
    },

    methods: {
        /**
         * Retorna a classe do ícone para o leaflet
         * @param {object} step informações da etapa do itinerário
         * @return {string} classes de exibição
         */
        getIconClass(step) {
            let html = "";
            
            switch (step.modifier) {
                case 'Left':
                    html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    else if(step.type == 'Left') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpLeft') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    else if(step.type == 'SlightLeft') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'Right':
                    html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    
                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    else if(step.type == 'Right') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpRight') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    else if(step.type == 'SlightRight') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'SlightRight':
                    html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    else if(step.type == 'Right') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpRight') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    else if(step.type == 'SlightRight') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'SlightLeft':
                    html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    else if(step.type == 'Left') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpLeft') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    else if(step.type == 'SlightLeft') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'SharpRight':
                    html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    else if(step.type == 'Right') html = 'leaflet-routing-icon leaflet-routing-icon-turn-right';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpRight') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-right';
                    else if(step.type == 'SlightRight') html = 'leaflet-routing-icon leaflet-routing-icon-bear-right';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'SharpLeft':
                    html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    //else if(step.type == 'DestinationReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else if(step.type == 'EndOfRoad') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    else if(step.type == 'Head') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Fork') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    else if(step.type == 'Left') html = 'leaflet-routing-icon leaflet-routing-icon-turn-left';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    else if(step.type == 'SharpLeft') html = 'leaflet-routing-icon leaflet-routing-icon-sharp-left';
                    else if(step.type == 'SlightLeft') html = 'leaflet-routing-icon leaflet-routing-icon-bear-left';
                    //else if(step.type == 'WaypointReached') html = 'leaflet-routing-icon leaflet-routing-icon-via';
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'Uturn') html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                case 'Straight':
                    html = 'leaflet-routing-icon leaflet-routing-icon-continue';

                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Straight') html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    else if(step.type == 'Roundabout') html = 'leaflet-routing-icon leaflet-routing-icon-enter-roundabout';
                    break;
                case 'Uturn':
                    html = 'leaflet-routing-icon leaflet-routing-icon-u-turn';
                    break;
                default:
                    if(step.type == 'Continue') html = 'leaflet-routing-icon leaflet-routing-icon-continue';                    
                    else if(step.type == 'WaypointReached') html = 'fa fa-map-marker-alt';
                    else if(step.type == 'DestinationReached') html = 'fa fa-flag';
                    else html = 'leaflet-routing-icon leaflet-routing-icon-continue';
                    break;
            }

            return html;
        },

        getDate: function(date) {
            let dateAux = new Date(date);
            let dateFormated = "";

            dateFormated = ((dateAux.getDate() < 10) ? "0" + dateAux.getDate() : dateAux.getDate()) + "/";
            dateFormated += (((dateAux.getMonth() + 1) < 10) ? "0" + (dateAux.getMonth() + 1) : (dateAux.getMonth() + 1)) + "/";
            dateFormated += dateAux.getFullYear();

            return dateFormated;
        },

        getTime: function(time) {
            let timeFormated = "";

            if(time < 3600) {
                timeFormated = Math.round(time / 60) + " min";
            } else {
                let timeHourAux = parseInt(time / 3600);
                let timeMinutAux = parseInt((time % 3600) / 60);

                if(timeMinutAux > 0) {
                    timeFormated = timeHourAux + " h " + timeMinutAux + " min";
                } else {
                    timeFormated = timeHourAux + " h ";
                }
            }
            
            return timeFormated;
        },

        getTimeHour: function(time) {
            time = time.split(":");
            return time[0] + ":" + time[1];
        },
        
        /**
         * Retorna o texto traduzido
         * @param {string} text texto do passo
         * @return {string} texto traduzido
         */
        getText: function(text) {
            // Verifica se te o texto em iglês
            if(text.includes('Exit the traffic circle onto')) {
                text = text.replace('Exit the traffic circle onto', 'Saia da rotatória para a');
            }
            // Retorna o texto modificado
            return text;
        },

        /**
         * Retorna a ditância
         * @param {number} distance ditância em metros
         * @return {string} distância em metros ou quilômetros
         */
        getDistance: function(distance) {
            let distanceFormated = "";
            
            if(distance < 1000)
                distanceFormated = distance.toFixed(1) + " m";
            else
                distanceFormated = (distance / 1000).toFixed(1) + " km";
                
            distanceFormated = distanceFormated.replace(".", ",");
            
            return distanceFormated;
        },
        
        /**
         * Retorna o peso
         * @param {number} weight peso em quilos
         * @return {string} peso em quilos ou toneladas
         */
        getWeight: function(weight) {
            let weightFormated = "";

            if(weight < 1000)
                weightFormated = weight.toFixed(2) + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

        /**
         * Mostra o marcador atual com zoom
         * @param {object} item ponto da rota
         *  */ 
        dblClick: function(item) {
            // Coloca o marcado mais visível
            item.setZIndexOffset(999).openPopup();
            
            // Atualiza o zom e center do map
            this.$parent.map.setView(item._latlng, 18, {
                animation: true
            });
        },
        
        /**
         * Mostra o marcador atual
         * @param {object} item ponto da rota
         *  */ 
        onMouseOver: function(item) {
            // Coloca o marcado mais visível
            item.setZIndexOffset(999).openPopup();
            
            // Atualiza o zom e center do map
            this.$parent.map.setView(item._latlng, 16, {
                animation: true
            });
        },

        /**
         * Retorna o marcador a z index anterior
         * @param {object} item ponto da rota
         *  */ 
        onMouseOut: function(item) {
            // Coloca o marcado mais visível
            item.setZIndexOffset(0).closePopup();
        },
        
        /**
		 * Adiciona o marcador ao mapa
		 * @param {number} index ínidice da coordenada
		 **/
        onMouseOverInstruction: function(index) {
			this.$emit("onMouseOverInstruction", index);
        },

        /**
         * Remove o marcado do mapa
         * @param {number} index ponto da rota
         **/ 
        onMouseOutInstruction: function() {
			this.$emit("onMouseOutInstruction");
        },

        /**
         * Muda a abra da tab
         * @param {string} view tab que será exibiba
         */
        changeSummary: function(view) {
            this.summary = view;
        },
    }
}
</script>

<style scoped>
.card {
    position: relative;
    height: auto;
    width: 400px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

.card-head {
    padding: 0px 15px;
    background-color: #a6a6a6;
    color: #404040;
    font-size: 14px;
}

.card-head-title {
    padding: 15px 8px;
    color: #000;
}

.card-head-button {
    padding: 0px;
    color: #000;
}

.buttom-close {
    padding: 15px 0px;
    width: 100%;
    float: left;
    border: none;
    background: none;
    z-index: 1;
    text-align: center;
}

.card-body {
    padding: 7px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.heading {
    margin-bottom: 5px;
    color: #AAA;
}

.geralSummary {
    padding: 10px 0px;
    font-size: 11px;
    text-align: center;
}

.geralDroppedNodesSummary {
    margin-bottom: -7px;
    padding: 10px;
    background-color: #f0f0f0;
    font-size: 12px;
    text-align: center;
}

.route,
.itinerary {
    height: 315px;
    overflow-y: auto;
    overflow-x: hidden;
}

.itinerary {
    overflow-x: hidden;
}

.tab {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
}

.buttom-tab {
    display: inline;
    padding: 10px;
    background-color: transparent;
    border: 1px solid transparent;
    border-bottom: 1px solid transparent;
    margin-bottom: -1px;
    cursor: pointer;
    color: #a2a2a2;
}

.buttom-tab:hover {
    background-color: #eeeeee;
    border-bottom: 1px solid #ccc;
}

.buttom-tab.active {
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
}

.buttom-tab.active:hover {
    background-color: transparent;
}

.itinerary > .leaflet-routing-alternatives-container > .leaflet-routing-alt {
    margin-top: 0px !important;
    border-bottom: none !important;
}

ul.list-points {
    position: relative;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-top: 10px;
    list-style-type: none;
}

/*ul.list-points:before {
    content: ' ';
    background: #ccc;
    display: inline-block;
    position: absolute;
    left: 22px;
    width: 2px;
    height: 100%;
    z-index: 3;
}*/

ul.list-points > li.list-points-item {
    padding: 0px 0px 30px 20px;
    margin: 0px 0px 0px 55px;
}

/*ul.list-points > li.list-points-item:hover {
   background-color: #f0f0f0;
}*/

ul.list-points > li.list-points-item > a {
    text-decoration: none;
    color: #404040;
    opacity: 1;
}

ul.totalRoute > li:first-child > a > .route-icon {
    position: absolute;
    display: inline-block;
    left: 8px;
    margin-top: 2px;
    z-index: 5;
}

ul.list-points > li.list-points-item > a > p {
    margin: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
}

ul.list-points > li.list-points-item > a > p.route-title {
    color: #404040;
    font-size: 12px;
    margin-bottom: 10px;
}

ul.list-points > li.list-points-item > a > p.route-title-lunch-time {
    color: #404040;
    font-size: 12px;
    margin-bottom: 5px;
}

ul.list-points > li.list-points-item > a > p.route-name {
    color: #404040;
    font-size: 10px;
    margin-bottom: 5px;
}

ul.list-points > li.list-points-item > a > p.route-description,
ul.list-points > li.list-points-item > a > p.route-address {
    font-size: 10px;
    color: #a2a2a2;
}

ul.list-points > li.list-points-item > a > p.route-description-separator {
    width: 80%;
    padding: 1px;
    background-color: #aaa;
    margin: 5px 0px;
}

ul.list-points > li.list-points-item > a > p.route-description.route-stopping {
    padding: 5px 0px;
    margin-bottom: 5px;
}

ul.list-points > li.list-points-item > a > p.route-description.route-stopping > span.route-stopping-text {
    padding: 5px;
    border-radius: 4px;
    background-color: #ccc;
    text-align: right;
    color: #404040;
}

ul.list-points > li.list-points-item > a > p.route-title-lunch-time {
    margin: 25px 0px 5px 0px;
}

ul.list-points > li.list-points-item > a > p.route-title-lunch-time > b.lunch-time {
    padding: 2px 5px;
    color: #000;
    background-color: #cdcdcd;
}

ul.list-points > li.list-points-item > a > span.route-marker {
    width: 30px;
    height: 30px;
    position: absolute;
    display: inline-block;
    left: 42px;
    margin-top: -8px;
    z-index: 4;
    border: 2px solid #fff;
    border-radius: 50% 50% 50% 0; 
    transform: rotate(-45deg);
}

ul.list-points > li.list-points-item > a > span.route-stopping-marker {
    border-radius: 10% 10% 10% 0;
}
ul.list-points > li.list-points-item > a > span.route-icon.dc-point-icon {
    position: absolute;
    display: inline-block;
    left: 49px;
    margin-top: -1px;
    font-size: 14px;
    z-index: 6;
}

ul.list-points > li.list-points-item > a > span.route-icon.stopping-point-icon {
    position: absolute;
    display: inline-block;
    margin-top: 0px;
    font-size: 13px;
    z-index: 6;
}

ul.list-points > li.list-points-item > a > span.route-icon.delivery-point-icon {
    position: absolute;
    display: inline-block;
    margin-top: 0px;
    font-size: 13px;
    z-index: 6;
}

ul.list-points > li.list-points-item > a > span.route-marker.dc-point-icon::after {
    content: "";
    width: 22px;
    height: 22px;
    position: absolute;
    display: inline-block;
    left: 2px;
    margin-top: 2px;
    z-index: 5;
    background-color: #fff;
    border-radius: 50%;
    font-size: 13px;
}

ul.list-points > li.list-points-item > a > span.route-marker.stopping-point-icon::after {
    content: "";
    width: 22px;
    height: 22px;
    position: absolute;
    display: inline-block;
    left: 2px;
    margin-top: 2px;
    z-index: 5;
    background-color: #fff;
    border-radius: 50%;
    font-size: 13px;
}

ul.list-points > li.list-points-item > a > span.route-marker.delivery-point-icon::after {
    content: "";
    width: 22px;
    height: 22px;
    position: absolute;
    display: inline-block;
    left: 2px;
    margin-top: 2px;
    z-index: 5;
    background-color: #fff;
    border-radius: 50%;
    font-size: 13px;
}

ul.list-points > li.list-points-item > a > span.route-distance {
    position: absolute;
    display: inline-block;
    left: 10px;
    margin-top: 25px;
    z-index: 5;
}

ul.list-points > li.list-points-item > a > span.route-time,
ul.list-points > li.list-points-item > a > span.route-lunch-time {
    position: absolute;
    display: inline-block;
    margin-top: 2px;
    left: 0;
    font-size: 11px;
    z-index: 6;
}

ul.list-points > li.list-points-item > a > span.route-lunch-time {
    margin-top: -31px;
}

ul.list-points > li.list-points-item:first-child > a > span.route-distance {
    position: absolute;
    display: inline-block;
    margin-top: 45px;
    left: 0;
    color: #a2a2a2;
    font-size: 11px;
    z-index: 6;
}

ul.list-points > li.list-points-item > a > span.route-distance {
    position: absolute;
    display: inline-block;
    margin-top: 55px;
    left: 0;
    color: #a2a2a2;
    font-size: 11px;
    z-index: 6;
}

.itinerary-total {
    margin: 10px 10px 10px 10px;
    font-size: 14px;
    color: #303030;
}

.itinerary-total > span {
    margin-left: 10px;
}

ul.list-steps {
    position: relative;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-top: 10px;
    list-style-type: none;
}

ul.list-steps > li.list-steps-item {
    padding: 15px 0px;
    font-size: 14px;
}

ul.list-steps > li.list-steps-item:hover {
    background-color: #fafafa;
    border: 1px solid #404040;
    border-radius: 5px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

ul.list-steps > li.list-steps-item > a {
    text-decoration: none;
    color: #404040;
    opacity: 1;
}

.step-orientation {
    text-align: center;
}

.step-description > p {
    margin: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
}

</style>